import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import FeaturedPostItem from '../components/FeaturedPostItem';

const FeaturedPosts = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allCosmicjsPosts(sort: { fields: [published_at], order: DESC }) {
            edges {
              node {
                title
                id
                slug
                content
                published_at(formatString: "DD MMMM, YYYY")
                metadata {
                  post_author {
                    title
                  }
                  tag {
                    title
                  }
                  description
                  main_image {
                    url
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        //console.log(data);
        return (
          <div>
            <div className="mt-20 text-center">
              <h2 className="text-3xl mb-8 lg:mb-0 leading-9 tracking-tight font-extrabold text-gray-700 sm:leading-10">
                The Consultant's Couch
              </h2>
            </div>
            <div className="relative bg-white md:pt-12 pb-20 px-4 sm:px-6 lg:pt-10 lg:pb-28 lg:px-8">
              <div className="relative max-w-7xl mx-auto">
                <div className="grid gap-5 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
                  {data.allCosmicjsPosts.edges.slice(0, 3).map(post => {
                    console.log(post);
                    return (
                      <FeaturedPostItem
                        key={post.node.id}
                        title={post.node.title}
                        date={post.node.published_at}
                        author={post.node.metadata.post_author.title}
                        description={post.node.metadata.description}
                        slug={'posts/' + post.node.slug}
                        image={post.node.metadata.main_image.url}
                        category={post.node.metadata.tag.map(tag => {
                          return (
                            <p class="-mt-2 -mb-2  leading-tight inline-block pr-2 ">
                              {tag.title + ','}
                            </p>
                          );
                        })}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="mt-10 text-center">
                <Link to="/blog/">
                  <button className=" focus:outline-none bg-secondary  rounded-full text-white tracking-wider inline-flex items-center px-16 py-4 border border-transparent text-sm leading-4 hover:bg-secondary-darker transition ease-in-out duration-500 ">
                    Take a seat on the Couch
                  </button>
                </Link>
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};

export default FeaturedPosts;

/*  <div className="relative bg-white md:pt-12 pb-20 px-4 sm:px-6 lg:pt-10 lg:pb-28 lg:px-8">
    <div className="relative max-w-7xl mx-auto">
      <div className="text-center">
        <h2 className="text-3xl leading-9 tracking-tight font-extrabold text-gray-700 sm:leading-10">
          The Consultant's Couch
        </h2>
      </div>
      <div className="mt-12 grid gap-5 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
        <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
          <div className="flex-shrink-0">
            <img
              className="h-48 w-full object-cover"
              src="https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
              alt=""
            />
          </div>
          <div className="flex-1 bg-white p-6 flex flex-col justify-between">
            <div className="flex-1">
              <p className="text-sm leading-5 font-medium text-indigo-600">
                <a href="#" className="hover:underline">
                  Blog
                </a>
              </p>
              <a href="#" className="block">
                <h3 className="mt-2 text-xl leading-7 font-semibold text-gray-900">
                  Boost your conversion rate
                </h3>
                <p className="mt-3 text-base leading-6 text-gray-500">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto accusantium
                  praesentium eius, ut atque fuga culpa, similique sequi cum eos quis dolorum.
                </p>
              </a>
            </div>
            <div className="mt-6 flex items-center">
              <div className="flex-shrink-0">
                <a href="#">
                  <img
                    className="h-10 w-10 rounded-full"
                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    alt=""
                  />
                </a>
              </div>
              <div className="ml-3">
                <p className="text-sm leading-5 font-medium text-gray-900">
                  <a href="#" className="hover:underline">
                    Roel Aufderhar
                  </a>
                </p>
                <div className="flex text-sm leading-5 text-gray-500">
                  <time datetime="2020-03-16">Mar 16, 2020</time>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hidden lg:flex lg:flex-col rounded-lg shadow-lg overflow-hidden">
          <div className="flex-shrink-0">
            <img
              className="h-48 w-full object-cover"
              src="https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
              alt=""
            />
          </div>
          <div className="flex-1 bg-white p-6 flex flex-col justify-between">
            <div className="flex-1">
              <p className="text-sm leading-5 font-medium text-indigo-600">
                <a href="#" className="hover:underline">
                  Second
                </a>
              </p>
              <a href="#" className="block">
                <h3 className="mt-2 text-xl leading-7 font-semibold text-gray-900">
                  Boost your conversion rate
                </h3>
                <p className="mt-3 text-base leading-6 text-gray-500">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto accusantium
                  praesentium eius, ut atque fuga culpa, similique sequi cum eos quis dolorum.
                </p>
              </a>
            </div>
            <div className="mt-6 flex items-center">
              <div className="flex-shrink-0">
                <a href="#">
                  <img
                    className="h-10 w-10 rounded-full"
                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    alt=""
                  />
                </a>
              </div>
              <div className="ml-3">
                <p className="text-sm leading-5 font-medium text-gray-900">
                  <a href="#" className="hover:underline">
                    Roel Aufderhar
                  </a>
                </p>
                <div className="flex text-sm leading-5 text-gray-500">
                  <time datetime="2020-03-16">Mar 16, 2020</time>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hidden lg:flex lg:flex-col rounded-lg shadow-lg overflow-hidden">
          <div className="flex-shrink-0">
            <img
              className="h-48 w-full object-cover"
              src="https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
              alt=""
            />
          </div>
          <div className="flex-1 bg-white p-6 flex flex-col justify-between">
            <div className="flex-1">
              <p className="text-sm leading-5 font-medium text-indigo-600">
                <a href="#" className="hover:underline">
                  Third
                </a>
              </p>
              <a href="#" className="block">
                <h3 className="mt-2 text-xl leading-7 font-semibold text-gray-900">
                  Boost your conversion rate
                </h3>
                <p className="mt-3 text-base leading-6 text-gray-500">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto accusantium
                  praesentium eius, ut atque fuga culpa, similique sequi cum eos quis dolorum.
                </p>
              </a>
            </div>
            <div className="mt-6 flex items-center">
              <div className="flex-shrink-0">
                <a href="#">
                  <img
                    className="h-10 w-10 rounded-full"
                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    alt=""
                  />
                </a>
              </div>
              <div className="ml-3">
                <p className="text-sm leading-5 font-medium text-gray-900">
                  <a href="#" className="hover:underline">
                    Roel Aufderhar
                  </a>
                </p>
                <div className="flex text-sm leading-5 text-gray-500">
                  <time datetime="2020-03-16">Mar 16, 2020</time>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>*/
